export default "__VITE_ASSET__DHzFzEjp__"